import { render, staticRenderFns } from "./EditTabModel.vue?vue&type=template&id=dae44dc2&"
import script from "./EditTabModel.vue?vue&type=script&lang=js&"
export * from "./EditTabModel.vue?vue&type=script&lang=js&"
import style0 from "./EditTabModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports